// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"33":"94a14577","835":"5a6adc2a"}[chunkId] + ".chunk.js";
};